import React, { useContext } from "react"
import Lightbox from "react-18-image-lightbox"
import RetinaImageWrapper from "../../../components/RetinaImage"
import { SpaceProfileContext } from "../context"

export default ({ thumbnails = [], thumbnailsRetina = [], images = [] }) => {
  const {
    commonData: { openLightBox, lightBoxIndex },
    actions: { setImageGalleryOpen, setImageGalleryIndex },
  } = useContext(SpaceProfileContext)

  return (
    <>
      <div className="space-profile-image-grid">
        <div className="row">
          <div className="col-sm-8 d-flex">
            <div className="image-zoom-container first-image">
              <div className="inner">
                {thumbnails.length > 0 ? (
                  <RetinaImageWrapper
                    image={thumbnails[0]}
                    retinaImage={thumbnailsRetina[0]}
                    className={"main-image"}
                    onClick={() => {
                      setImageGalleryOpen(true)
                      setImageGalleryIndex(1)
                    }}
                  />
                ) : (
                  <img
                    className={"main-image"}
                    src={images[1]}
                    alt=""
                    onClick={() => {
                      setImageGalleryOpen(true)
                      setImageGalleryIndex(1)
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="row">
              {thumbnails.length > 0
                ? thumbnails.slice(1, 3).map((image, idx) => {
                    return (
                      <div className="col-12 d-flex" key={idx}>
                        <div className="image-zoom-container">
                          <div className="inner">
                            <img
                              className={`img-` + idx}
                              src={thumbnailsRetina[idx + 1].url}
                              alt=""
                              onClick={() => {
                                setImageGalleryOpen(true)
                                setImageGalleryIndex(idx + 2)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  })
                : images.slice(2, 4).map((image, idx) => {
                    return (
                      <div className="col-12 d-flex" key={idx}>
                        <div className="image-zoom-container secondary-image">
                          <div className="inner">
                            <img
                              className={`img-` + idx}
                              src={image}
                              alt=""
                              onClick={() => {
                                setImageGalleryOpen(true)
                                setImageGalleryIndex(idx + 2)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  })}
            </div>
          </div>

          <div className="col-sm-12">
            <button
              className="btn btn-sp-profile"
              onClick={() => {
                setImageGalleryOpen(true)
                setImageGalleryIndex(0)
              }}
            >
              See All Photos
            </button>
          </div>

          {openLightBox && (
            <Lightbox
              enableZoom={false}
              mainSrc={images[lightBoxIndex]}
              nextSrc={images[(lightBoxIndex + 1) % images.length]}
              prevSrc={
                images[(lightBoxIndex + images.length - 1) % images.length]
              }
              onCloseRequest={() => setImageGalleryOpen(false)}
              onMovePrevRequest={() =>
                setImageGalleryIndex(
                  (lightBoxIndex + images.length - 1) % images.length
                )
              }
              onMoveNextRequest={() =>
                setImageGalleryIndex((lightBoxIndex + 1) % images.length)
              }
            />
          )}
        </div>
      </div>
    </>
  )
}
